import { defineMessages } from 'react-intl.macro';

export default defineMessages({
  reports: {
    id: 'components.menuItem.reports',
    defaultMessage: 'Raporty okresowe'
  },
  currentReports: {
    id: 'components.menuItem.currentReports',
    defaultMessage: 'Raporty bieżące'
  },
  financialResults: {
    id: 'components.menuItem.financialResults',
    defaultMessage: 'Wyniki finansowe'
  },
  shareholders: {
    id: 'components.menuItem.shareholders',
    defaultMessage: 'Akcjonariat spółki'
  },
  generalMeetings: {
    id: 'components.menuItem.generalMeetings',
    defaultMessage: 'Walne zgromadzenia'
  },
  strategy: {
    id: 'components.menuItem.strategy',
    defaultMessage: 'Strategia'
  },
  mission: {
    id: 'components.menuItem.mission',
    defaultMessage: 'Wizja i misja'
  },
  authorities: {
    id: 'components.menuItem.authorities',
    defaultMessage: 'Władze'
  },
  mediaAboutUs: {
    id: 'components.menuItem.mediaAboutUs',
    defaultMessage: 'Media o spółce'
  },
  csr: {
    id: 'components.menuItem.csr',
    defaultMessage: 'CSR'
  },
  corporateGovernance: {
    id: 'components.menuItem.corporateGovernance',
    defaultMessage: 'Ład korporacyjny'
  },
  history: {
    id: 'components.menuItem.history',
    defaultMessage: 'Historia'
  },
  infoAboutCompany: {
    id: 'components.menuItem.infoAboutCompany',
    defaultMessage: 'Rynek i działalność spółki'
  },
  plannedEvents: {
    id: 'components.menuItem.plannedEvents',
    defaultMessage: 'Wydarzenia'
  },
  issueOfShares: {
    id: 'components.menuItem.issueOfShares',
    defaultMessage: 'Emisja Akcji'
  },
  presentations: {
    id: 'components.menuItem.presentations',
    defaultMessage: 'Prezentacje inwestorskie'
  }
});



// WEBPACK FOOTER //
// ./src/common/messages/ForInvestorsMenu.intl.js